/*
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 * 
 * 
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *            佛祖保佑       永不宕机     永无BUG
 * 
 * @Author: 王新
 * @Date: 2021-04-28 10:22:03
 * @FilePath: \operation-screen\src\config\api.js
 * @Description: 声明的接口
 */

import config from './config'

export const allRefresh = config.baseUrl + "/system/cacheStatisTicsController/allRefresh" // 所有的刷新接口
export const mapRefresh = config.baseUrl + "/system/cacheStatisTicsController/mapRefresh" // 地图联动信息查询
export const userRefresh = config.baseUrl + "/system/cacheStatisTicsController/userRefresh" // 用户信息查询
export const positionOrgListStatistics = config.baseUrl + "/system/cacheStatisTicsController/positionOrgListStatistics" // 查询地图上的点
export const mapStreetRefresh = config.baseUrl + "/system/cacheStatisTicsController/mapStreetRefresh" //凯旋街道联动信息查询
export const allStreetRefresh = config.baseUrl + "/system/cacheStatisTicsController/allStreetRefresh" // 凯旋街道所有的刷新接口
export const kyyBigScreen = config.baseUrl + "/system/wechat/kyyOrganizationPcController/kyyBigScreen" //  社会组织 雷法图  排名查询